import { IconArrowLeft, IconTrash, IconUpload } from "@tabler/icons-react";
import axios from "axios";
import { useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { BannerContext, ServerUrl, pause } from "../Utils";
import { ModalContext } from "../contexts/Contexts";
import { Button } from "./Button";
import DestructiveActionButton from "./DestructiveActionBtn";
import { swapContent } from "./Modal";

function ResearcherTools({ isOpen, setIsOpen, userInfo }) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [willClose, setWillClose] = useState(false);

  const [banner, setBanner] = useContext(BannerContext);
  const { contentElement } = useContext(ModalContext);
  const navigate = useNavigate();

  async function handleSignOut() {
    await axios
      .post(`${ServerUrl}/users/logout`, {}, { withCredentials: true })
      .catch();
    navigate("/home");
  }

  async function handleDeleteAccount() {
    if (userInfo) {
      await axios
        .delete(`${ServerUrl}/users/${userInfo.participantId}`, {
          withCredentials: true,
        })
        .then(() => {
          handleSignOut();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async function handleReturn() {
    if (confirmDelete) {
      setWillClose(true);
      await pause(250);
    }
    swapContent(contentElement, async () => {
      await pause(100);
      setIsOpen(false);
      setWillClose(false);
      await pause(100);
    });
  }

  return (
    isOpen && (
      <>
        <Helmet>
          <title>Researcher Tools</title>
        </Helmet>
        <div className="btn-group">
          <Button
            variant="secondary"
            icon={
              <IconArrowLeft
                style={{ boxSizing: "border-box", paddingRight: "0.2rem" }}
                stroke={2.5}
              />
            }
            label="Return to Profile"
            styles={{ width: "100%" }}
            onClick={handleReturn}
          />

          <Button
            className="upload-users"
            label="Upload Users"
            variant="light"
            icon={<IconUpload />}
            onClick={() => navigate("/research/upload")}
            styles={{ width: "100%" }}
          />

          <DestructiveActionButton
            actionLabel={(confirm) =>
              confirm ? "Yes, Delete" : "Delete Account"
            }
            actionIcon={IconTrash}
            cancelLabel="Cancel"
            warningHeader={<>This action cannot be undone.</>}
            warningMessage={<>Are you sure you want to delete your account?</>}
            willClose={willClose}
            confirmState={[confirmDelete, setConfirmDelete]}
            onActionConfirm={handleDeleteAccount}
          />
        </div>
      </>
    )
  );
}

export default ResearcherTools;
